export default {
  title: 'Pay with {{method}}',
  hint: 'Tap the button below and approve the payment in the {{method}} window.',
  confirming: 'Confirming your payment…',
  cancel: 'Cancel payment',
  unavailable: 'This payment method is not available right now. Choose another one.',
  approval_timeout:
    'We did not hear back from {{method}}. If its window did not open, check that pop-ups are allowed, then try again or choose another payment method.',
};
